import { z } from 'zod';

export const getAssortmentsSchema = z.array(
  z.object({
    id: z.string(),
    bindingType: z.number(),
    traderGroupItemID: z.string(),
    traderGroupItemNamePath: z.string(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
  })
);

export type GetAssortmentsResponse = z.infer<typeof getAssortmentsSchema>;
